import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetSearchResultsDealerUseCase extends UseCase {
  constructor({config, getRequestSearchService, repository, fromSearchToSearchResultsDealerRequestMapper}) {
    super()
    this._config = config
    this._getRequestSearchService = getRequestSearchService
    this._repository = repository
    this._fromSearchToSearchResultsDealerRequestMapper = fromSearchToSearchResultsDealerRequestMapper
  }

  @inlineError
  async execute({pageName, searchQuery}) {
    const searchRequest = await this._getRequestSearchService
      .execute({
        query: searchQuery,
        context: pageName
      })
      .then(response => response?.toCleanJSON())

    const requestVO = this._fromSearchToSearchResultsDealerRequestMapper.map({
      search: searchRequest
    })

    const [error, response] = await this._repository.getSearchResults({
      requestVO
    })

    if (error) return Promise.reject(error)

    return {
      ...response.toJSON(),
      search: searchRequest
    }
  }
}
